export const iconColors = {
  lightBlue: '#3b82f6',
  white: 'white'
};
